
import jquery from './jquery-3.2.1.js';

export default (window.$ = window.jQuery = jquery);
